import { useSyncExternalStore } from 'react'
import { calculateRemainingTime, WeeklyPromoState } from '../utils/weeklyPromo'

/**
 * One shared ticker for the whole site. Every countdown and every "ends Sunday"
 * line subscribes to the same store, so they can never disagree, and only one
 * interval runs no matter how many components display the promotion.
 */

let state: WeeklyPromoState = calculateRemainingTime()
const listeners = new Set<() => void>()
let timer: number | undefined

function tick() {
  state = calculateRemainingTime()
  listeners.forEach((listener) => listener())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  if (timer === undefined) {
    tick()
    timer = window.setInterval(tick, 1000)
  }
  return () => {
    listeners.delete(listener)
    if (listeners.size === 0 && timer !== undefined) {
      window.clearInterval(timer)
      timer = undefined
    }
  }
}

export function useWeeklyPromo(): WeeklyPromoState {
  return useSyncExternalStore(subscribe, () => state, () => state)
}
